import React, { Component } from 'react'
import Helmet from 'react-helmet'
import { Breadcrumb } from '../../elements'

class BikeBreadCrumbs extends Component {
  constructor(props) {
    super(props)

    const { region, city, make, category } = this.props

    let breadCrumbsSchemaList = {
      '@context': 'https://schema.org/',
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          item: 'https://www.twistedroad.com/listings/' + region,
          name: region,
          position: 1,
        },
        {
          '@type': 'ListItem',
          item: 'https://www.twistedroad.com/listings/' + region + '/' + city,
          name: city + ', ' + region,
          position: 2,
        },
        {
          '@type': 'ListItem',
          item:
            'https://www.twistedroad.com/listings/' +
            region +
            '/' +
            city +
            '/' +
            make,
          name: make,
          position: 3,
        },
        {
          '@type': 'ListItem',
          item:
            'https://www.twistedroad.com/listings/' +
            region +
            '/' +
            city +
            '/' +
            make +
            '/' +
            category,
          name: category,
          position: 4,
        },
      ],
    }

    this.state = {
      breadCrumbSchema: breadCrumbsSchemaList,
    }
  }

  render() {
    const { make, category, region, city } = this.props

    return (
      <React.Fragment>
        <Helmet>
          <script type="application/ld+json">
            {JSON.stringify(this.state.breadCrumbSchema)}
          </script>
        </Helmet>

        <Breadcrumb
          className="link is-uppercase mb-1 is-size-7 has-text-weight-bold"
          size="small"
          separator={'succeeds'}
          items={[
            {
              name: region,
              url: '/listings/' + region,
            },
            {
              name: city,
              url: '/listings/' + region + '/' + city,
            },
            {
              url: '/listings/' + region + '/' + city + '/' + make,
              name: make,
            },
            {
              url:
                '/listings/' +
                region +
                '/' +
                city +
                '/' +
                make +
                '/' +
                category,
              name: category,
            },
          ]}
        />
      </React.Fragment>
    )
  }
}
export default BikeBreadCrumbs

BikeBreadCrumbs.defaultProps = {
  city: '',
  region: '',
  make: '',
  category: '',
}
